import React, { useRef, useState } from 'react';
import { InputLabel } from '@material-ui/core';
import { PrimaryButton } from '../../../Core/FormInput';
import DialogComp from '../../../Core/Modal/dialogModal';

const InspectionImages = ({ state, setState, disabled, hideBtn }) => {
    const [img, setImg] = useState(false);

    const fileInputRef = useRef(null);
    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setState((st) => ({ ...st, vehicleInspectionBrakeTestPhoto: reader.result }));
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleImageChange = async (event) => {
        const file = event.target.files[0];

        if (file) {
            const image = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                image.src = e.target.result;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Maintain original aspect ratio
                    const MAX_WIDTH = 800; // Set your maximum width for compression
                    const scaleFactor = Math.min(MAX_WIDTH / image.width, 1);

                    canvas.width = image.width * scaleFactor;
                    canvas.height = image.height * scaleFactor;

                    // Draw image on canvas to compress
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                    // Convert canvas to data URL
                    const compressedBase64 = canvas.toDataURL('image/jpeg', 0.6); // Compression quality (0.7 = 70%)
                    console.log('Compressed Image Base64:', compressedBase64);
                    setState((st) => ({ ...st, vehicleInspectionBrakeTestPhoto: compressedBase64 }));
                };
            };

            reader.readAsDataURL(file);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };
    const openImag = () => {
        setImg(!img);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', height: '100%' }}>
            <input
                type="file"
                // accept="image/*"
                accept="image/*, application/pdf, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleImageChange}
                ref={fileInputRef}
                style={{ display: 'none' }}
            />
            <div>
                <InputLabel>&nbsp;</InputLabel>
                {!hideBtn && (
                    <PrimaryButton onClick={handleButtonClick} disabled={disabled}>
                        {state.vehicleInspectionBrakeTestPhoto ? 'Update Image' : 'Upload Image'}
                    </PrimaryButton>
                )}
            </div>
            {state.vehicleInspectionBrakeTestPhoto && (
                <img
                    src={state.vehicleInspectionBrakeTestPhoto}
                    alt="Uploaded Preview"
                    style={{ maxWidth: '30%', maxHeight: '60px', cursor: 'pointer' }}
                    onClick={openImag}
                />
            )}
            {img ? (
                <div style={{ padding: 10 }}>
                    <DialogComp onClose={openImag}>
                        <img
                            src={state.vehicleInspectionBrakeTestPhoto}
                            alt="Uploaded Preview"
                            style={{ marginTop: '50px', maxWidth: '100%', objectFit: 'cover' }}
                        />
                    </DialogComp>
                </div>
            ) : null}
        </div>
    );
};

export default InspectionImages;
